import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { BinarySwitch } from '../../../atomic/buttons/binarySwitch/BinarySwitch';
import { Body4, Heading4 } from '../../../atomic/text/Text';
import { AllOpenOrders } from './orderCollections/AllOpenOrders';
import { AllOrders } from './orderCollections/AllOrders';
import style from './OrdersTable.module.css';
import { headerList } from './headerList';
import { colors } from '../../../../colorVars';

export const OrdersTable = observer(({ size }) => {
  const [showOnlyOpenOrders, setShowOnlyOpenOrders] = useState(true);
  let ListComponent;
  if (showOnlyOpenOrders) ListComponent = AllOpenOrders;
  else ListComponent = AllOrders;

  return (
    <div className={style.container}>
      <header className={style.header}>
        <Heading4 color={colors.lightGrey}>Orders</Heading4>
        <div className={style.buttons}>
          <BinarySwitch
            label1="Open Orders"
            label2="All Orders"
            value={showOnlyOpenOrders}
            setValue={setShowOnlyOpenOrders}
            margin="0 5px 0 15px"
          />
        </div>
        <Body4 fontWeight={700} color={colors.lightGrey} margin="0 0 0 10px">
          * editable field if open
        </Body4>
      </header>
      <div className={style.tableContainer}>
        <table className={style.table}>
          <ListComponent size={size} headerList={headerList} />
        </table>
      </div>
    </div>
  );
});

OrdersTable.propTypes = {
  size: PropTypes.string,
};
